import { useSession } from "app/hooks/useSession";
import SysUser from "app/class/sysUser";
import { createContext, ReactNode, useContext, useMemo } from "react";

type AuthContextValue = {
    user: SysUser | null;
    isAuthenticated: boolean;
    isLoading: boolean;
};

const AuthContext = createContext<AuthContextValue | null>(null);

// export const AuthProvider = ({ children }: { children: ReactNode }) => {
//     const { data, isLoading, isError } = useSession();

//     const value = useMemo<AuthContextValue>(() => ({
//         user: isError ? null : data ?? null,
//         isAuthenticated: !!data && !isError,
//         isLoading,
//     }), [data, isError, isLoading]);

//     return (
//         <AuthContext.Provider value={value}>
//             {children}
//         </AuthContext.Provider>
//     );
// };



export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const { data, isLoading } = useSession();

    const value = useMemo<AuthContextValue>(() => ({
        user: data || null,
        isAuthenticated: !!data,
        isLoading,
    }), [data, isLoading]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextValue => {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error("useAuth must be used inside AuthProvider");
    }
    return ctx;
};
